
const VocabProfessionalsContent = {
    'professionals_section_id': ['professionals', 'professionals'],
    'professionals_section_title': ['Profesionales', 'professionals'],

    'FAQ_section_id': ['faq', 'professionals'],
    'FAQ_section_title': ['FAQ', 'professionals'],

    'FAQ_Q1_id': ['faq_01', 'faq_01'],
    'FAQ_Q1_title': ['¿Como no morir?', 'FAQ'],
    'FAQ_Q1_body': [
        'Respirando :)', 
        'Addresses'
    ],

    'FAQ_Q2_id': ['faq_02', 'faq_02'],
    'FAQ_Q2_title': ['¿Como si morir?', 'FAQ'],
    'FAQ_Q2_body': [
        'Votando por MORENA ¬¬', 
        'Addresses'
    ],
    
    'help_section_id': ['help', 'help'],
    'help_section_title': ['Ayuda', 'Help'],

    'privacy_section_id': ['privacy', 'privacy'],
    'privacy_section_title': ['Privacidad', 'Privacy'],

    'pricing_section_id': ['pricing', 'pricing'],
    'pricing_section_title': ['Precios', 'Pricing'],


    'plans_id': ['plans', 'plans'],
    'FAQ_Q1_title': ['Planes', 'Plans'],
    'FAQ_Q1_body': [
        'Respirando :)', 
        'Addresses'
    ],


    'benefits_id': ['benefits', 'benefits'],
    'FAQ_Q1_title': ['Beneficios', 'Benefits'],
    'FAQ_Q1_body': [
        'Respirando :)', 
        'Addresses'
    ],
  }
  export default VocabProfessionalsContent;
    